import { LoginResult } from '@/services/typing';

const key = 'user';

export const setUserData = (data: LoginResult) => {
  localStorage.setItem(key, JSON.stringify(data));
};

export const getUserData = (): LoginResult | null => {
  const data = localStorage.getItem(key);
  if (!data) {
    return null;
  }
  try {
    return JSON.parse(data);
  } catch (error) {
    console.error('解析用户数据失败:', error);
    return null;
  }
};

export const clearUserData = () => {
  localStorage.removeItem(key);
};
